import { render, staticRenderFns } from "./sectionbox.vue?vue&type=template&id=1eedae50&scoped=true&"
import script from "./sectionbox.vue?vue&type=script&lang=js&"
export * from "./sectionbox.vue?vue&type=script&lang=js&"
import style0 from "./sectionbox.vue?vue&type=style&index=0&id=1eedae50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eedae50",
  null
  
)

export default component.exports